<template>  
<div> <!-- root element start -->

  <transition name="slide-fade" mode="out-in">
    <component 
      :is="mainView" 
      :prop1="mvProp1" 
      :prop2="mvProp2" 
      :prop3="mvProp3" 
      @onSComplete="successComplete" 
      @onUComplete="unsuccessComplete"
      @onSecondary="secondaryAction"
    >
    </component>
  </transition>

</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/quote-builder-main-store.js'


import quoteMain from '../quoteBuilderComponents/quote-builder-main.vue'
import quoteBuild from '../quoteBuilderComponents/quote-builder-builder.vue'
import quoteView from '../quoteBuilderComponents/quote-builder-view.vue'


export default {
  store,
  props: ['inst'],
  data: function () {
    return { 
      result: [],
    }
  },
  computed: {
    mainView () { return this.$store.state.mainView },
    mvProp1 () { return this.$store.state.mvProp1 },
    mvProp2 () { return this.$store.state.mvProp2 },
    mvProp3 () { return this.$store.state.mvProp3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllUserQuotes();
    this.getAllUserContacts();
    this.getAllUserOrgs();
    this.getAllUserBuilds();
    this.onLoad();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },
    getAllUserQuotes() { this.$store.dispatch("getAllUserQuotes") },
    getAllUserBuilds() { this.$store.dispatch("getAllUserBuilds") },
    getAllUserOrgs() { this.$store.dispatch("getAllUserOrgs") },
    getAllUserContacts() { this.$store.dispatch("getAllUserContacts") },
    
    onLoad(){
      var _this = this;
      if(_this.inst != null && _this.inst != '') {
        var get = _this.inst.split('_');
        switch(get[0]) {
          case "0": // send to main
          break;
          case "1": // send to view
            var setup = ['', get[1]];
            _this.getMainView('quote-view', '', '', setup);
          break;
          case "2": // send to builder

          break;

        }
      }
    },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-builder':
        _this.getAllUserQuotes();
        var setup = ['', value[1]];
        _this.getMainView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-builder':
          _this.getMainView('quote-main', '', '', '');
        break;
        case 'quote-view':
          _this.getMainView('quote-main', '', '', '');
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-view':
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },

  },    
  components:{
    'quote-main' : quoteMain,
    'quote-builder' : quoteBuild,
    'quote-view' : quoteView,
  },
  filters: {

  }
}
</script>
